import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { BASE_URL } from "../../const";
import Navbar from '../../components/Navbar'; 

const BatchListPage = () => {
  const [batches, setBatches] = useState([]);
  const [days, setDays] = useState(1);
  const [filter, setFilter] = useState("pending");

  const username = localStorage.getItem("username");
  const isAdmin = username === "admin";

  const warehouseOptions = [
    { value: "SELECT BRANDS (I) PVT. LTD. (PUNE)", label: "Pune" },
    { value: "SELECT BRANDS (I) PVT. LTD. (KOLKATA)", label: "Kolkata" },
    { value: "DELHI WAREHOUSE", label: "Delhi-1" },
  ];

  const [selectedWarehouse, setSelectedWarehouse] = useState(warehouseOptions[0].value);

  const navigate = useNavigate();

  const fetchBatches = async () => {
    const token = localStorage.getItem("token");
    const localStore = localStorage.getItem("store");
    const storeToUse = isAdmin ? selectedWarehouse : localStore;

    try {
      const res = await axios.get(`${BASE_URL}/get_batches_data?days=${days}`, {
        headers: {
          Authorization: `Token ${token}`,
          Store: storeToUse,
        },
      });
      setBatches(res.data);
    } catch (err) {
      console.error("Error fetching batch data", err);
    }
  };

  // Refetch data when 'days' or selected warehouse changes
  useEffect(() => {
    fetchBatches();
  }, [days, selectedWarehouse]);

  const filteredBatches = batches.filter((batch) =>
    filter === "pending"
      ? batch.percentage_completed < 100
      : batch.percentage_completed === 100
  );

  return (
    <>
      <Navbar title="Dashboard" />

      <div className="p-4 space-y-4">
        {/* Filters */}
        <div className="flex flex-wrap justify-between items-center gap-2">
          {/* Days Dropdown */}
          <select
            value={days}
            onChange={(e) => setDays(e.target.value)}
            className="border rounded px-3 py-1 text-sm"
          >
            <option value="1">Last 1 Day</option>
            <option value="3">Last 3 Days</option>
            <option value="5">Last 5 Days</option>
          </select>

          {/* Admin-only Warehouse Dropdown */}
          {isAdmin && (
            <div className="flex items-center gap-2">
              <label className="text-sm text-gray-700 font-medium">Warehouse:</label>
              <select
                value={selectedWarehouse}
                onChange={(e) => setSelectedWarehouse(e.target.value)}
                className="border rounded px-3 py-1 text-sm"
              >
                {warehouseOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Pending/Completed Filter */}
          <div className="flex gap-2 text-sm">
            <button
              onClick={() => setFilter("pending")}
              className={`px-3 py-1 rounded ${filter === "pending" ? "bg-blue-600 text-white" : "bg-gray-400 text-white"}`}
            >
              Pending
            </button>
            <button
              onClick={() => setFilter("completed")}
              className={`px-3 py-1 rounded ${filter === "completed" ? "bg-blue-600 text-white" : "bg-gray-400 text-white"}`}
            >
              Completed
            </button>
          </div>
        </div>

        {/* Cards */}
        <div className="grid gap-3 sm:grid-cols-2">
          {filteredBatches.map((batch) => (
            <div
              key={batch.batch_id}
              onClick={() => navigate(`/batch/${batch.batch_id}`)}
              className="bg-white shadow rounded-xl p-4 cursor-pointer hover:bg-gray-50 transition"
            >
              <div className="flex justify-between items-center">
                <h3 className="text-md font-semibold text-gray-800">
                  Batch- {batch.batch_id}
                </h3>
                <span
                  className={`text-xs px-2 py-1 rounded-full ${
                    batch.percentage_completed === 100
                      ? "bg-green-100 text-green-700"
                      : "bg-yellow-100 text-yellow-700"
                  }`}
                >
                  {batch.percentage_completed === 100 ? "Completed" : "Pending"}
                </span>
              </div>
              <p className="text-sm text-gray-600 mt-1">
                Date: <strong>{batch.date}</strong>
              </p>
              <p className="text-sm text-gray-600">
                Quantity: {batch.total_qty}, Varieties:{" "}
                <strong> {batch.unique_variety} </strong>
              </p>
              <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-500"
                  style={{ width: `${batch.percentage_completed}%` }}
                ></div>
              </div>
              <p className="text-xs text-gray-500 mt-1 text-right">
                {Number(batch.percentage_completed || 0).toFixed(2)}% completed
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BatchListPage;
